<style>
</style>
<script>
import { authComputed, authMethods } from '@state/helpers'

import MetisMenu from 'metismenujs/dist/metismenujs'

export default {
  components: {},
  computed: {
    ...authComputed,
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu')
    var links = document.getElementsByClassName('side-nav-link-ref')
    var matchingMenuItem = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname.includes('/account/detail')) {
        matchingMenuItem = links[i]
        break
      }
      if (
        window.location.pathname.includes('/field') &&
        links[i].pathname.includes('/field')
      ) {
        matchingMenuItem = links[i]
        break
      }
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement

      if (parent.classList.contains('menu-single')) {
        return true
      }

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active')
        const parent2 = parent.parentElement
        if (parent2) {
          parent2.classList.add('in')
        }
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add('active')
          parent3.firstChild.classList.add('active')
        }
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add('in')
        }
        const parent5 = parent4.parentElement
        if (parent5) {
          parent5.classList.add('active')
          parent5.firstChild.classList.add('active')
        }
      }
    }
  },
  methods: {
    ...authMethods,
  },
}
</script>

<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul id="side-menu" class="metismenu">
      <li class="menu-title">Navigation</li>

      <li v-if="$store.getters['auth/hasPriv'](4)" class="menu-single">
        <!-- <router-link
          tag="a"
          to="/comparison-study"
          class="side-nav-link-ref"
          title="Comparison Study"
        >
          <i class="mdi mdi-chart-bar"></i>
          <span>Comparison Study</span>
        </router-link> -->
      </li>

      <li class="menu-single">
        <router-link
          tag="a"
          to="/field/well"
          class="side-nav-link-ref"
          title="Home"
        >
          <i class="mdi mdi-home"></i>
          <span>Home</span>
        </router-link>
      </li>

      <li
        v-if="
          $store.getters['auth/hasPriv'](1) ||
          $store.getters['auth/hasPriv'](2) ||
          $store.getters['auth/hasPriv'](3)
        "
      >
        <a
          href="javascript: void(0);"
          aria-expanded="false"
          class="has-dropdown"
          title="Account Management"
        >
          <i class="mdi mdi-airplay"></i>
          <span>Account Management</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li v-if="$store.getters['auth/hasPriv'](1)">
            <router-link
              tag="a"
              to="/account"
              class="side-nav-link-ref"
              title="Client Details"
              >Client Details</router-link
            >
          </li>
          <li v-if="$store.getters['auth/hasPriv'](2)">
            <router-link
              tag="a"
              to="/account/create"
              class="side-nav-link-ref"
              title="Manage Account"
              >Manage Account</router-link
            >
          </li>
          <li v-if="$store.getters['auth/hasPriv'](3)">
            <router-link
              tag="a"
              to="/account/log-activity"
              class="side-nav-link-ref"
              title="Log Activity"
              >Log Activity</router-link
            >
          </li>
        </ul>
      </li>

      <li v-if="currentWell && $store.getters['auth/hasPriv'](14)">
        <a
          href="javascript: void(0);"
          aria-expanded="false"
          class="has-dropdown menu-level-3"
          title="Field Dashboard"
        >
          <i class="mdi mdi-apps"></i>
          <span>Field Dashboard</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level nav" aria-expanded="false">
          <li>
            <router-link
              tag="a"
              to="/dashboard/drilling-program-field"
              class="side-nav-link-ref"
              title="Drilling Program"
              >Drilling Program</router-link
            >
          </li>
          <li>
            <router-link
              tag="a"
              to="/dashboard/bit-performance-field"
              class="side-nav-link-ref"
              title="Bit Performance"
              >Bit Performance</router-link
            >
          </li>
          <li>
            <router-link
              tag="a"
              to="/dashboard/npt-analysis-field"
              class="side-nav-link-ref"
              title="Drilling Program"
              >NPT Analysis</router-link
            >
          </li>
          <li>
            <router-link
              tag="a"
              to="/dashboard/activity-breakdown-field"
              class="side-nav-link-ref"
              title="Drilling Program"
              >Activity Breakdown</router-link
            >
          </li>
          <li>
            <a
              href="javascript: void(0);"
              aria-expanded="false"
              class="has-dropdown"
              title="Cost Breakdown"
            >
              Cost Breakdown
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/cost-breakdown/progress-cost-field"
                  class="side-nav-link-ref"
                  title="Progress Cost"
                  >Progress Cost</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/cost-breakdown/afe-vs-actual-field"
                  class="side-nav-link-ref"
                  title="Actual vs AFE"
                  >Actual vs AFE</router-link
                >
              </li>
            </ul>
          </li>
          <li>
            <router-link
              tag="a"
              to="/dashboard/drilling-parameters-field"
              class="side-nav-link-ref"
              title="Drilling Parameters"
              >Drilling Parameters</router-link
            >
          </li>
          <!-- <li>
            <router-link
              tag="a"
              to="/dashboard/subsurface-summary"
              class="side-nav-link-ref"
              title="Subsurface Summary"
              >Subsurface Summary</router-link
            >
          </li> -->
        </ul>
      </li>
      <li v-if="currentWell && $store.getters['auth/hasPriv'](14)">
        <a
          href="javascript: void(0);"
          aria-expanded="false"
          class="has-dropdown menu-level-3"
          title="Well Dashboard"
        >
          <i class="mdi mdi-view-dashboard"></i>
          <span>Well Dashboard</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level nav" aria-expanded="false">
          <li>
            <router-link
              tag="a"
              to="/dashboard"
              class="side-nav-link-ref"
              title="Well Information"
              >Well Information</router-link
            >
          </li>
          <li>
            <router-link
              tag="a"
              to="/dashboard/one-page"
              class="side-nav-link-ref"
              title="One Page"
              >One Page</router-link
            >
          </li>
          <li>
            <a
              href="javascript: void(0);"
              aria-expanded="false"
              class="has-dropdown"
              title="Cost Breakdown"
            >
              Drilling & Cost Progress
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/drilling-progress/summary"
                  class="side-nav-link-ref"
                  title="Drilling & Cost Progress - Summary"
                  >Drilling Progress Summary</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/drilling-progress/activity-breakdown"
                  class="side-nav-link-ref"
                  title="Drilling & Cost Progress - Activity Breakdown"
                  >Drilling Progress</router-link
                >
              </li>
              <!-- li>
                <router-link
                  tag="a"
                  to="/dashboard/cost-breakdown/progress-cost"
                  class="side-nav-link-ref"
                  title="Progress Cost"
                  >Progress Cost</router-link
                >
              </li -->
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/cost-breakdown/progress-cost"
                  class="side-nav-link-ref"
                  title="Actual vs AFE"
                  >Cost Progress (charts on slide 14 & 15)</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/cost-breakdown/cum-cost-per-contract-category"
                  class="side-nav-link-ref"
                  title="Cost per Contract"
                  >Cost per Contract</router-link
                >
              </li>
            </ul>
          </li>
          <li>
            <router-link
              tag="a"
              to="/dashboard/drilling-program"
              class="side-nav-link-ref"
              title="Drilling Program"
              >Drilling Program</router-link
            >
          </li>
          <li>
            <a
              href="javascript: void(0);"
              aria-expanded="false"
              class="has-dropdown"
              title="Drilling Performance"
            >Drilling Performance<span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/drilling-performance/activity-breakdown"
                  class="side-nav-link-ref"
                  title="Drilling Program - Activity Breakdown"
                  >Activity Breakdown</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/drilling-performance/npt-breakdown"
                  class="side-nav-link-ref"
                  title="Drilling Program - NPT Breakdown"
                  >NPT Breakdown</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/drilling-performance/npt-hole-section"
                  class="side-nav-link-ref"
                  title="Drilling Program - NPT per Hole Section"
                  >NPT per Hole Section</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/drilling-performance/equipment-failure-breakdown"
                  class="side-nav-link-ref"
                  title="Drilling Program - NPT of Equipment Failure Breakdown"
                  >Equipment Failure Breakdown</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/drilling-performance/drilling-phase-breakdown"
                  class="side-nav-link-ref"
                  title="Drilling Program - Drilling Phase Breakdown"
                  >Drilling Phase Breakdown</router-link
                >
              </li>
            </ul>
          </li>
          <!-- li>
            <router-link
              tag="a"
              to="/dashboard/drilling-progress"
              class="side-nav-link-ref"
              title="Drilling Progress"
              >Drilling Progress</router-link
            >
          </li -->
          <li>
            <a
              href="javascript: void(0);"
              aria-expanded="false"
              class="has-dropdown"
              title="Bit Performance"
            >
              Bit Performance
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/bit-performance"
                  class="side-nav-link-ref"
                  title="Bit Performance - Performance By Manufacturer"
                  >Performance By Manufacturer</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/dashboard/bit-performance-cpf-mse"
                  class="side-nav-link-ref"
                  title="Bit Performance - CPF and MSE"
                  >CPF and MSE</router-link
                >
              </li>
            </ul>
          <li>
            <router-link
              tag="a"
              to="/dashboard/drilling-parameters"
              class="side-nav-link-ref"
              title="Drilling Parameters"
              >Drilling Parameters</router-link
            >
          </li>
        </ul>
      </li>
      <li
        v-if="
          currentWell &&
          ($store.getters['auth/hasPriv'](9) ||
            $store.getters['auth/hasPriv'](10) ||
            $store.getters['auth/hasPriv'](11) ||
            $store.getters['auth/hasPriv'](12) ||
            $store.getters['auth/hasPriv'](13))
        "
      >
        <a
          href="javascript: void(0);"
          aria-expanded="false"
          class="has-dropdown"
          title="Add Report"
        >
          <i class="mdi mdi-folder-plus"></i>
          <span>Add Report</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li v-if="$store.getters['auth/hasPriv'](10)">
            <router-link
              tag="a"
              to="/form/daily-drilling-report"
              class="side-nav-link-ref"
              title="Daily Drilling Report"
              >Daily Drilling Report</router-link
            >
          </li>
          <!-- DEveleopment -->
          <!-- <li v-if="$store.getters['auth/hasPriv'](11)">
            <router-link tag="a" to="/form/drilling-activity" class="side-nav-link-ref" title="Drilling Activity">Drilling Activity</router-link>
          </li>-->
          <li v-if="$store.getters['auth/hasPriv'](11)">
            <a
              href="javascript: void(0);"
              aria-expanded="false"
              class="has-dropdown"
              title="Drilling Activity Report"
            >
              Drilling Activity Report
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <router-link
                  tag="a"
                  to="/form/drilling-activity/casing"
                  class="side-nav-link-ref"
                  title="Casing"
                  >Casing</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/form/drilling-activity/kick"
                  class="side-nav-link-ref"
                  title="Kick"
                  >Kick</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/form/drilling-activity/cement"
                  class="side-nav-link-ref"
                  title="Cementing"
                  >Cementing</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/form/drilling-activity/coring"
                  class="side-nav-link-ref"
                  title="Coring"
                  >Coring</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/form/drilling-activity/logging"
                  class="side-nav-link-ref"
                  title="Logging"
                  >Logging</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/form/drilling-activity/fishing"
                  class="side-nav-link-ref"
                  title="Fishing"
                  >Fishing</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/form/drilling-activity/well-test"
                  class="side-nav-link-ref"
                  title="Well Test"
                  >Well Test</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/form/drilling-activity/general-work"
                  class="side-nav-link-ref"
                  title="General Work"
                  >General Work</router-link
                >
              </li>
            </ul>
          </li>
          <!-- DEveleopment
          <li v-if="$store.getters['auth/hasPriv'](12)">
            <router-link
              tag="a"
              to="/form/subsurface-form"
              class="side-nav-link-ref"
              title="Subsurface Form"
              >Lithology Report</router-link
            >
          </li -->
          <li v-if="$store.getters['auth/hasPriv'](9)">
            <router-link
              tag="a"
              to="/form/planner-form"
              class="side-nav-link-ref"
              title="Planner Form"
              >Planner Form</router-link
            >
          </li>
        </ul>
      </li>
      <li
        v-if="currentWell && $store.getters['auth/hasPriv'](13)"
        class="menu-single approval"
      >
        <router-link
          tag="a"
          to="/form/approval-form"
          class="side-nav-link-ref"
          title="Report Approval"
        >
          <i class="mdi mdi-checkbox-multiple-marked"></i>
          <span>Report Approval</span></router-link
        >
      </li>
      <li
        v-if="
          currentWell &&
          ($store.getters['auth/hasPriv'](5) ||
            $store.getters['auth/hasPriv'](6) ||
            $store.getters['auth/hasPriv'](7) ||
            $store.getters['auth/hasPriv'](8))
        "
      >
        <a
          href="javascript: void(0);"
          aria-expanded="false"
          class="has-dropdown"
          title="Database"
        >
          <i class="mdi mdi-database"></i>
          <span>Database</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li v-if="$store.getters['auth/hasPriv'](5)">
            <router-link
              tag="a"
              to="/database/daily-drilling-report"
              class="side-nav-link-ref"
              title="Daily Drilling Report"
              >Daily Drilling Report</router-link
            >
          </li>
          <li v-if="$store.getters['auth/hasPriv'](6)">
            <!-- <router-link tag="a" to="/database/drilling-activity" class="side-nav-link-ref" title="Drilling Activity">Drilling Activity</router-link> -->
            <a
              href="javascript: void(0);"
              aria-expanded="false"
              class="has-dropdown"
              title="Drilling Activity"
            >
              Drilling Activity
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <router-link
                  tag="a"
                  to="/database/drilling-activity/casing"
                  class="side-nav-link-ref"
                  title="Casing"
                  >Casing</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/database/drilling-activity/kick"
                  class="side-nav-link-ref"
                  title="Kick"
                  >Kick</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/database/drilling-activity/cement"
                  class="side-nav-link-ref"
                  title="Cementing"
                  >Cementing</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/database/drilling-activity/coring"
                  class="side-nav-link-ref"
                  title="Coring"
                  >Coring</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/database/drilling-activity/logging"
                  class="side-nav-link-ref"
                  title="Logging"
                  >Logging</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/database/drilling-activity/fishing"
                  class="side-nav-link-ref"
                  title="Fishing"
                  >Fishing</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/database/drilling-activity/well-test"
                  class="side-nav-link-ref"
                  title="Well Test"
                  >Well Test</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/database/drilling-activity/general-work"
                  class="side-nav-link-ref"
                  title="General Work"
                  >General Work</router-link
                >
              </li>
            </ul>
          </li>
          <!-- li v-if="$store.getters['auth/hasPriv'](7)">
            <router-link
              tag="a"
              to="/database/subsurface"
              class="side-nav-link-ref"
              title="Approval Form"
              >Lithology Database</router-link
            >
          </li -->
          <!-- <li v-if="$store.getters['auth/hasPriv'](8)">
            <router-link
              tag="a"
              to="/database/planner"
              class="side-nav-link-ref"
              title="Subsurface Form"
              >Planner Database</router-link
            >
          </li> -->
        </ul>
      </li>
      <li
        v-if="
          currentWell &&
          ($store.getters['auth/hasPriv'](5) ||
            $store.getters['auth/hasPriv'](6) ||
            $store.getters['auth/hasPriv'](7) ||
            $store.getters['auth/hasPriv'](8))
        "
      >
        <a
          href="javascript: void(0);"
          aria-expanded="false"
          class="has-dropdown"
          title="Database"
        >
          <i class="mdi mdi-file-check"></i>
          <span>Reports</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li v-if="$store.getters['auth/hasPriv'](5)">
            <router-link
              tag="a"
              to="/report/daily-drilling-report"
              class="side-nav-link-ref"
              title="Daily Drilling Report"
              >Daily Drilling Report</router-link
            >
          </li>
          <li v-if="$store.getters['auth/hasPriv'](6)">
            <a
              href="javascript: void(0);"
              aria-expanded="false"
              class="has-dropdown"
              title="Drilling Activity"
            >
              Drilling Activity
              <span class="menu-arrow"></span>
            </a>
            <ul class="nav-third-level nav" aria-expanded="false">
              <li>
                <router-link
                  tag="a"
                  to="/report/drilling-activity/casing"
                  class="side-nav-link-ref"
                  title="Casing"
                  >Casing</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/report/drilling-activity/kick"
                  class="side-nav-link-ref"
                  title="Kick"
                  >Kick</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/report/drilling-activity/cement"
                  class="side-nav-link-ref"
                  title="Cementing"
                  >Cementing</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/report/drilling-activity/coring"
                  class="side-nav-link-ref"
                  title="Coring"
                  >Coring</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/report/drilling-activity/logging"
                  class="side-nav-link-ref"
                  title="Logging"
                  >Logging</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/report/drilling-activity/fishing"
                  class="side-nav-link-ref"
                  title="Fishing"
                  >Fishing</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/report/drilling-activity/well-test"
                  class="side-nav-link-ref"
                  title="Well Test"
                  >Well Test</router-link
                >
              </li>
              <li>
                <router-link
                  tag="a"
                  to="/report/drilling-activity/general-work"
                  class="side-nav-link-ref"
                  title="General Work"
                  >General Work</router-link
                >
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- End Sidebar -->
</template>

<style lang="scss">
@import '~metismenujs/scss/metismenujs';
</style>
